import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { ADMIN } from "@/constants/testIds";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && user !== false && user !== null) {
      nav("/admin/dashboard", { replace: true });
    }
  }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      nav("/admin/dashboard");
    } else {
      setErr(res.error || "Login failed");
    }
  };

  return (
    <div className="App min-h-screen flex flex-col">
      <SiteHeader />
      <section className="max-w-md mx-auto w-full px-6 lg:px-8 pt-20 pb-24 flex-1">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-full bg-[#3DA9DC]/10 text-[#2C8FBE] grid place-items-center mx-auto">
            <Lock size={20} />
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl mt-4 text-[#122036]">Staff sign-in</h1>
          <p className="text-stone-600 text-sm mt-2">Access the delivery management dashboard.</p>
        </div>
        <form
          onSubmit={onSubmit}
          className="bg-white rounded-2xl border border-stone-200 p-7 shadow-[0_4px_24px_rgba(0,0,0,0.04)] space-y-5"
        >
          <div className="space-y-2">
            <Label htmlFor={ADMIN.loginEmail}>Email</Label>
            <Input
              id={ADMIN.loginEmail}
              data-testid={ADMIN.loginEmail}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-xl"
              autoComplete="email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={ADMIN.loginPassword}>Password</Label>
            <Input
              id={ADMIN.loginPassword}
              data-testid={ADMIN.loginPassword}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-xl"
              autoComplete="current-password"
            />
          </div>
          {err && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-4 py-2.5">
              {err}
            </div>
          )}
          <Button
            data-testid={ADMIN.loginSubmit}
            type="submit"
            disabled={busy}
            className="w-full bg-[#122036] hover:bg-[#0B1626] text-white rounded-full py-6 text-base"
          >
            {busy ? "Signing in…" : "Sign in"}
          </Button>
          <div className="text-center">
            <Link to="/" className="text-xs text-stone-500 hover:text-stone-700">← Back to public map</Link>
          </div>
        </form>
      </section>
      <SiteFooter />
    </div>
  );
}
